import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
import type { ListType } from "@shared/types/QuickOrderList";

interface ProductListEntityParams {
  quick_order_list_id: number;
  name: string;
  layout: string;
  listType?: ListType;
}
export class ProductListEntity extends BaseEntityClass {
  quick_order_list_id: number;
  name: string;
  layout: string;
  list_type?: ListType;
  constructor(params: ProductListEntityParams) {
    super();
    this.type = "product_list";
    this.entity_version = 2;
    this.quick_order_list_id = params.quick_order_list_id;
    this.name = params.name;
    this.layout = params.layout;
    this.list_type = params.listType;
  }
}
